export default "__VITE_ASSET__43f06d67__"